/* =============================================================================
   MASCA — Comportamiento del home de marca propia
   -----------------------------------------------------------------------------
   Un solo archivo para todas las secciones "masca-*". Hace cuatro cosas:

     1. Traduce la COBERTURA REAL del backend a los badges de despacho.
     2. Maneja los selectores de cantidad.
     3. Agrega al carro sin recargar (y abre el cart drawer nativo de Dawn).
     4. Muestra la barra de compra sticky del celular cuando el hero se va.

   POR QUÉ LOS BADGES NO SON TEXTO FIJO
   "Llega Mañana" y "Envío Gratis" no son adornos: para el saco de 12 kg
   "mañana" es literalmente la ruta BODEGA (el partner despacha al día
   siguiente, con corte a las 21:00). Si la comuna del comprador no tiene fila
   en `shipping_rates` para esa ruta, no hay next day y decirlo sería mentir.
   Por eso el badge se pinta desde lo que respondió /apps/masca/coverage, que
   el popup de ubicación ya dejó guardado en localStorage (`mascaRutas`).

   CONTRATO CON EL RESTO DEL TEMA (no inventado acá, ya existía):
     localStorage.userAddress   -> dirección elegida
     localStorage.userCity      -> comuna
     localStorage.mascaRutas    -> csv: express,nextday,bodega,retiro
     localStorage.mascaEta      -> minutos estimados
     #change-location-btn       -> el disparador que abre el popup de ubicación
     evento 'masca:cobertura-actualizada' -> lo emite masca-cobertura-refresh.js
   ========================================================================== */
(function () {
  'use strict';

  if (window.mascaHomeCargado) return; // el archivo lo pueden pedir varias secciones
  window.mascaHomeCargado = true;

  /* ==========================================================================
     1. COBERTURA
     ====================================================================== */

  var Cobertura = {
    /** Rutas habilitadas para la dirección guardada. [] si no hay dirección. */
    rutas: function () {
      try {
        return (localStorage.getItem('mascaRutas') || '')
          .split(',')
          .map(function (r) {
            return r.trim();
          })
          .filter(Boolean);
      } catch (err) {
        return []; // modo privado / cookies bloqueadas
      }
    },

    tiene: function (ruta) {
      return this.rutas().indexOf(ruta) !== -1;
    },

    direccion: function () {
      try {
        return localStorage.getItem('userAddress') || '';
      } catch (err) {
        return '';
      }
    },

    /** Abre el popup de ubicación reusando el disparador que ya vive en el tema. */
    pedirDireccion: function () {
      var disparador = document.getElementById('change-location-btn');
      if (disparador) {
        disparador.click();
      } else {
        window.location.href = '/';
      }
    }
  };

  window.MascaCobertura = Cobertura; // por si una sección futura lo necesita

  /*
    Traduce las rutas a lo que el comprador entiende. El orden importa: si hay
    express se promete hoy, que es la promesa más fuerte; si no, mañana.
  */
  function promesaDeEntrega() {
    if (!Cobertura.direccion()) {
      return { estado: 'sin-direccion' };
    }
    var rutas = Cobertura.rutas();
    if (rutas.indexOf('express') !== -1) {
      return { estado: 'hoy', texto: 'Llega hoy' };
    }
    if (rutas.indexOf('bodega') !== -1 || rutas.indexOf('nextday') !== -1) {
      return { estado: 'manana', texto: 'Llega mañana' };
    }
    if (rutas.indexOf('retiro') !== -1) {
      return { estado: 'retiro', texto: 'Retiro en tienda disponible' };
    }
    return { estado: 'sin-cobertura' };
  }

  var ICONO_RAYO =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M13 2 4.5 13.5H11l-1 8.5 8.5-11.5H12l1-8.5Z"/></svg>';
  var ICONO_CAMION =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 5h11v9H3V5Zm12 3h3.5L21 11.5V14h-6V8ZM6.5 19a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6Zm11 0a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6Z"/></svg>';
  var ICONO_PIN =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z"/></svg>';

  /**
   * Pinta los badges de despacho dentro de un contenedor [data-masca-badges].
   * data-envio-gratis-desde = cantidad a partir de la cual el envío es gratis
   * (es una promo comercial, editable en el Customizer, no un cálculo).
   */
  function pintarBadges(contenedor) {
    var promesa = promesaDeEntrega();
    var html = '';

    if (promesa.estado === 'sin-direccion') {
      html =
        '<span class="masca-pill masca-pill--alerta">' +
        ICONO_PIN +
        '<button type="button" class="masca-badges__link" data-masca-pedir-direccion>' +
        'Ingresa tu dirección para ver el despacho</button></span>';
    } else if (promesa.estado === 'sin-cobertura') {
      html =
        '<span class="masca-pill masca-pill--alerta">' +
        ICONO_PIN +
        '<span>Aún no llegamos a tu comuna</span></span>';
    } else {
      html =
        '<span class="masca-pill masca-pill--ok">' +
        ICONO_RAYO +
        '<span>' +
        promesa.texto +
        '</span></span>';

      // El envío gratis solo se promete cuando la promo aplica de verdad.
      var desde = parseInt(contenedor.getAttribute('data-envio-gratis-desde') || '0', 10);
      var cantidad = cantidadActual(contenedor);
      if (desde > 0 && cantidad >= desde && promesa.estado !== 'retiro') {
        html +=
          '<span class="masca-pill masca-pill--ok">' +
          ICONO_CAMION +
          '<span>Envío gratis</span></span>';
      }
    }

    contenedor.innerHTML = html;
  }

  /** Cantidad vigente para decidir si aplica el envío gratis. */
  function cantidadActual(contenedor) {
    var declarada = contenedor.getAttribute('data-cantidad');
    if (declarada) return parseInt(declarada, 10) || 1;
    var seccion = contenedor.closest('.masca-seccion') || document;
    var input = seccion.querySelector('[data-masca-qty-input]');
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  function pintarTodosLosBadges() {
    document.querySelectorAll('[data-masca-badges]').forEach(pintarBadges);
  }

  /* ==========================================================================
     2. CANTIDAD
     ====================================================================== */

  function conectarCantidad(raiz) {
    raiz.querySelectorAll('[data-masca-qty]').forEach(function (grupo) {
      var input = grupo.querySelector('[data-masca-qty-input]');
      if (!input) return;

      grupo.querySelectorAll('[data-masca-qty-boton]').forEach(function (boton) {
        boton.addEventListener('click', function () {
          var paso = parseInt(boton.getAttribute('data-masca-qty-boton'), 10) || 0;
          var valor = (parseInt(input.value, 10) || 1) + paso;
          input.value = Math.max(1, valor);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      input.addEventListener('change', function () {
        if ((parseInt(input.value, 10) || 0) < 1) input.value = 1;
        pintarTodosLosBadges();
        actualizarPreciosDependientes();
      });
    });
  }

  /* ==========================================================================
     3. PRECIOS QUE DEPENDEN DE LA CANTIDAD
     ====================================================================== */

  /** Formatea pesos chilenos: 71980 -> "$71.980". Shopify guarda ×100. */
  function pesos(centavos) {
    var enteros = Math.round(centavos / 100);
    return '$' + enteros.toLocaleString('es-CL');
  }

  window.mascaPesos = pesos;

  /**
   * Recalcula los importes que dependen de la cantidad elegida (el total del
   * hero y el de la barra sticky). Cada nodo declara el precio unitario en
   * data-precio-unitario (en centavos, como lo entrega Shopify).
   */
  function actualizarPreciosDependientes() {
    document.querySelectorAll('[data-precio-total]').forEach(function (nodo) {
      var unitario = parseInt(nodo.getAttribute('data-precio-unitario'), 10);
      if (isNaN(unitario)) return;
      var seccion = nodo.closest('.masca-seccion') || document;
      var input = seccion.querySelector('[data-masca-qty-input]');
      var cantidad = input ? parseInt(input.value, 10) || 1 : 1;
      nodo.textContent = pesos(unitario * cantidad);
    });
  }

  /* ==========================================================================
     4. AGREGAR AL CARRO
     ====================================================================== */

  /**
   * El carro que muestra el tema: puede ser la notificación o el drawer.
   * Se busca con la MISMA precedencia que usa product-form.js del tema, porque
   * cada uno declara qué secciones necesita para repintarse.
   */
  function elementoDelCarro() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  /**
   * Agrega al carro por fetch y repinta el carro del tema. Si algo falla
   * (JS muerto, carro ausente), cae al /cart de toda la vida: el comprador
   * nunca se queda sin poder comprar por culpa de nuestro javascript.
   *
   * OJO CON `is-empty` — acá se perdió una tarde:
   * el tema marca <cart-drawer class="drawer is-empty"> cuando la página cargó
   * con el carro vacío, y el CSS con esa clase esconde el encabezado y colapsa
   * `.drawer__inner` a una sola fila. Pero `renderContents()` solo reemplaza el
   * HTML de #CartDrawer, que es HIJO de <cart-drawer>: la clase sobrevive. Sin
   * quitarla a mano, el drawer se abre con el total correcto y la lista de
   * productos en blanco. El tema lo resuelve igual, en el `.finally()` de
   * product-form.js.
   */
  function agregarAlCarro(variantId, cantidad, boton) {
    var textoOriginal = boton ? boton.innerHTML : '';
    if (boton) {
      boton.disabled = true;
      boton.setAttribute('aria-busy', 'true');
    }

    var carro = elementoDelCarro();

    // Cada carro dice qué secciones necesita; pedir otras las deja sin repintar.
    var secciones = [];
    if (carro && typeof carro.getSectionsToRender === 'function') {
      secciones = carro.getSectionsToRender().map(function (seccion) {
        return seccion.id;
      });
    }

    var cuerpo = {
      items: [{ id: variantId, quantity: cantidad }],
      // Shopify renderiza las secciones en el contexto de esta URL; sin esto
      // las armaría contra la home y en otra página saldrían equivocadas.
      sections_url: window.location.pathname
    };
    if (secciones.length) cuerpo.sections = secciones;

    if (carro && typeof carro.setActiveElement === 'function' && boton) {
      carro.setActiveElement(boton);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (respuesta) {
        if (!respuesta.ok) throw new Error('cart/add respondió ' + respuesta.status);
        return respuesta.json();
      })
      .then(function (estado) {
        if (carro && typeof carro.renderContents === 'function' && estado.sections) {
          carro.renderContents(estado);
          // La clase vive en el elemento padre, fuera de lo que repinta
          // renderContents: si no se quita, el carro se ve vacío.
          if (carro.classList.contains('is-empty')) carro.classList.remove('is-empty');
          actualizarContadorCarro();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (error) {
        console.error('[masca-home] no se pudo agregar al carro:', error);
        window.location.href = '/cart';
      })
      .finally(function () {
        if (boton) {
          boton.disabled = false;
          boton.removeAttribute('aria-busy');
          boton.innerHTML = textoOriginal;
        }
      });
  }

  function conectarAgregar(raiz) {
    // Formularios (hero): se interceptan, pero siguen siendo <form> válidos.
    raiz.querySelectorAll('[data-masca-form]').forEach(function (form) {
      form.addEventListener('submit', function (evento) {
        var variante = form.querySelector('[name="id"]');
        var cantidad = form.querySelector('[name="quantity"]');
        if (!variante || !variante.value) return; // sin variante: que lo maneje Shopify
        evento.preventDefault();
        /*
          Cinturón y tirantes contra el doble envío: `slider-products.js` engancha
          un submit propio en cualquier `form[action="/cart/add"]` y duplicaba el
          pedido. El `action` del hero ya no calza con ese selector, y esto corta
          cualquier otro listener que se sume después.
          Funciona porque este archivo va con `defer`: se ejecuta antes del
          DOMContentLoaded donde el otro script se registra, así que este listener
          queda primero.
        */
        evento.stopImmediatePropagation();
        agregarAlCarro(
          variante.value,
          parseInt(cantidad ? cantidad.value : '1', 10) || 1,
          form.querySelector('[type="submit"]')
        );
      });
    });

    // Botones sueltos (planes y barra sticky): traen variante y cantidad fijas.
    raiz.querySelectorAll('[data-masca-agregar]').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var variante = boton.getAttribute('data-variante');
        if (!variante) {
          Cobertura.pedirDireccion();
          return;
        }
        var cantidad = parseInt(boton.getAttribute('data-cantidad'), 10) || 1;
        agregarAlCarro(variante, cantidad, boton);
      });
    });
  }

  /**
   * Refresca el globito del carro en el header. Se pregunta a /cart.js en vez
   * de contar a mano: el carro puede traer líneas de otras pestañas o del
   * cart drawer, y el número del header no puede mentir.
   */
  function actualizarContadorCarro() {
    var contadores = document.querySelectorAll('[data-masca-cart-count]');
    if (!contadores.length) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (respuesta) {
        return respuesta.json();
      })
      .then(function (carro) {
        contadores.forEach(function (nodo) {
          nodo.textContent = carro.item_count;
          nodo.classList.toggle('masca-oculto', carro.item_count === 0);
        });
      })
      .catch(function () {
        /* si falla, el contador se queda como estaba: no vale recargar por esto */
      });
  }

  /* ==========================================================================
     COLAPSABLES POR ANCHO (ficha del hero, columnas del footer)
     ====================================================================== */

  /*
    POR QUÉ ESTO NO SE HACE CON CSS.
    El truco clásico —`details:not([open]) > *:not(summary) { display: block }`—
    dejó de funcionar: Chrome implementa el estado cerrado de <details> con
    `content-visibility: hidden` sobre el slot del contenido, y eso esconde todo
    el subárbol sin importar el `display` que tengan los hijos. En el footer se
    veían los títulos de las columnas y ningún enlace debajo.

    Así que el estado lo maneja el JavaScript: el markup viene ABIERTO (si el JS
    no carga, se ve todo) y acá se cierra cuando la pantalla es angosta.
  */
  function conectarColapsables(raiz) {
    raiz.querySelectorAll('[data-masca-colapsable]').forEach(function (detalle) {
      if (detalle.dataset.mascaColapsableListo) return; // no conectarlo dos veces
      detalle.dataset.mascaColapsableListo = '1';

      var desde = parseInt(detalle.getAttribute('data-masca-colapsable'), 10) || 750;
      var anchaEs = window.matchMedia('(min-width: ' + desde + 'px)');

      // Solo se fuerza al cruzar el breakpoint: si el comprador abre una columna
      // en el celular, se queda como la dejó.
      function aplicar() {
        detalle.open = anchaEs.matches;
      }

      aplicar();
      if (typeof anchaEs.addEventListener === 'function') {
        anchaEs.addEventListener('change', aplicar);
      } else if (typeof anchaEs.addListener === 'function') {
        anchaEs.addListener(aplicar); // Safari antiguo
      }
    });
  }

  /* ==========================================================================
     5. BARRA DE COMPRA STICKY (mobile)
     ====================================================================== */

  /*
    Aparece cuando el bloque de compra del hero sale de pantalla. En un celular
    el precio y el botón quedan arriba de todo y el comprador pasa el resto del
    scroll sin forma de comprar; la barra devuelve esa acción a la mano.
  */
  function conectarBarraSticky() {
    var barra = document.querySelector('[data-masca-barra]');
    if (!barra) return;

    var ancla = document.querySelector('[data-masca-ancla-compra]');
    if (!ancla || !('IntersectionObserver' in window)) {
      barra.classList.remove('masca-oculto');
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          barra.classList.toggle('masca-barra--visible', !entrada.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -40% 0px' }
    );
    observador.observe(ancla);
  }

  /* ==========================================================================
     ARRANQUE
     ====================================================================== */

  function iniciar() {
    conectarCantidad(document);
    conectarAgregar(document);
    conectarColapsables(document);
    conectarBarraSticky();
    pintarTodosLosBadges();
    actualizarPreciosDependientes();

    // Cualquier botón puede pedir la dirección (los badges pintan uno adentro).
    document.addEventListener('click', function (evento) {
      var disparador = evento.target.closest('[data-masca-pedir-direccion]');
      if (disparador) {
        evento.preventDefault();
        Cobertura.pedirDireccion();
      }
    });
  }

  // Cuando el backend refresca la cobertura, los badges se repintan solos.
  document.addEventListener('masca:cobertura-actualizada', pintarTodosLosBadges);

  // El editor de temas recarga secciones sueltas: hay que reconectarlas.
  document.addEventListener('shopify:section:load', function (evento) {
    conectarCantidad(evento.target);
    conectarAgregar(evento.target);
    conectarColapsables(evento.target);
    conectarBarraSticky();
    pintarTodosLosBadges();
    actualizarPreciosDependientes();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
